import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcContextMenuItems]'
})
export class ContextMenuItemsDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
